var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkDevice, ttfb } from "@total_onion/onion-utils";
import modalController from "@total_onion/onion-modalcontroller";
import lazyloaderV3 from "@total_onion/onion-library/onion-loader";
import jsAssets from "Assets/js/modules/jsAssets.js";
import setupLenis from "Assets/js/modules/lenis.js";
import testNetworkSpeed from "Assets/js/modules/networktest";
import shop from "Assets/js/modules/shop";
import initLiquidCommerceButtons from "Assets/js/modules/liquid-commerce-buttons";
let shopJs = () => {
    const loadEShop = document.querySelector("html").dataset.eshop;
    if (loadEShop === "true") {
        shop.shopShopify(true);
        shop.checkCart(); // eager-loading Shopify?
    }
};
let runLazyLoadv3 = () => {
    lazyloaderV3.options.projectAssets = jsAssets.dynamicAssets;
    lazyloaderV3.lazyloaderInit();
};
function enableModalController() {
    const popupController = new modalController({
        closeSelector: "[data-modalpopupclose], #modal-controller-popup__close-btn",
        closeDelay: 500,
        closingClass: "is-closing",
        activateDelay: 50,
        lenis: true,
    });
}
function yieldToMain() {
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
}
window.addEventListener("DOMContentLoaded", () => {
    function runSiteJs() {
        return __awaiter(this, void 0, void 0, function* () {
            const tasks = [
                initLiquidCommerceButtons,
                ttfb,
                checkDevice,
                setupLenis,
                runLazyLoadv3,
                enableModalController,
                setupLenis,
                shopJs,
                testNetworkSpeed,
            ];
            while (tasks.length > 0) {
                const task = tasks.shift();
                task();
                yield yieldToMain();
            }
        });
    }
    runSiteJs();
});
